/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { fetchTeamMetrics } from '../../../../../api/MetricsService';
import Teams from '../../../../../api/Teams';
import Auth from '../../../../../routes/Auth';
import { Loader } from 'react-loaders';
import AbbreviatedMillionNumberFormat from "../../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class SharePriceStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      marketValue: 0,
      shares: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;

    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);
    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const roundId = round ? round.id : 0;
    const prevRound = rounds.find(i => Number(i.number) === Number(activeRound) - 1);
    const prevRoundId = prevRound ? prevRound.id : 0;

    const currentPromise = fetchTeamMetrics(teamId, roundId);
    const prevPromise = prevRoundId ? fetchTeamMetrics(teamId, prevRoundId) : Promise.resolve([]);

    Promise.all([currentPromise, prevPromise])
      .then(([currentResults, prevResults]) => {
        const currentRoundMetrics = currentResults.find(i => (
          Number(i.game) === gameId && Number(i.round) === roundId
        ));
        const prevRoundMetrics = prevResults.find(i => (
          Number(i.game) === gameId && Number(i.round) === prevRoundId
        ));

        const marketValue = currentRoundMetrics ? Number(currentRoundMetrics.total_market_capital || 0) : 0;
        let shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
        if (prevRoundMetrics) {
          const prevShares = Number(prevRoundMetrics.shares || 0);
          shares = (shares + prevShares) / 2;
        }

        this.setState({
          loaded: true,
          marketValue,
          shares,
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      marketValue,
      shares,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="SHARE PRICE"
        previousShownErrors={previousShownErrors}
        alertText="Here’s what impacted your share price."
        paragraph2={(
          <Fragment>
            In round 1 &amp; 2, investors determine your valuation by taking your revenues
            and applying a revenue multiplier, which is
            commonly known as: <a href="https://www.investopedia.com/terms/p/price-to-salesratio.asp" target="_blank" rel="noreferrer">price to sales ratio</a>.
            Therefore higher revenues should drive a higher valuation and hopefully a higher share price.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#6fd1d9" padding="30px 53px" color="rgba(0, 27, 59, 0.94)">
              Share Price
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Business Value
              <span className='divider' />
              Average Shares Outstanding
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={marketValue}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={shares}
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#d7f0f2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default SharePriceStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/share-price/step2.js